import { useSyncExternalStore } from "react";

import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";

import type { PapelGuia } from "./pasos";

/**
 * Qué guía está abierta (una sola para toda la app, se abra desde Inicio, el menú de usuario o la
 * bienvenida). Estado de módulo: no se guarda entre recargas.
 */
let abierta: PapelGuia | null = null;
const avisar = new Set<() => void>();

export const abrirGuia = (papel: PapelGuia) => {
  abierta = papel;
  avisar.forEach((f) => f());
};

export const cerrarGuia = () => {
  abierta = null;
  avisar.forEach((f) => f());
};

export const useGuiaAbierta = () =>
  useSyncExternalStore(
    (f) => {
      avisar.add(f);
      return () => avisar.delete(f);
    },
    () => abierta,
  );

const clave = (id: string | number) => `nevora.guia.vista.${id}`;

/**
 * ¿Ya se le ofreció la guía a esta persona? En su cuenta (metadatos de Supabase Auth, vale para
 * cualquier dispositivo) y, por rapidez, en este navegador.
 */
export const guiaVista = async (id: string | number): Promise<boolean> => {
  try {
    if (localStorage.getItem(clave(id))) return true;
  } catch {
    // Sin almacenamiento local (navegación privada): se mira solo la cuenta.
  }
  const { data } = await getSupabaseClient().auth.getSession();
  return !!data.session?.user.user_metadata?.guia_vista;
};

/** Apunta que ya se le ofreció (se cierre con «Ver la guía» o con «Ahora no»). */
export const marcarGuiaVista = async (id: string | number) => {
  try {
    localStorage.setItem(clave(id), "1");
  } catch {
    // Sin almacenamiento local: queda en la cuenta.
  }
  try {
    // Supabase junta estos datos con los que ya tiene la cuenta (nombre y apellidos siguen).
    await getSupabaseClient().auth.updateUser({
      data: { guia_vista: new Date().toISOString() },
    });
  } catch {
    // Si falla, en este navegador ya no sale; en otro, saldría otra vez: no es grave.
  }
};
